var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 212,
    viewBox: "46.089 47.089 119.568 117.822",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.873 59.7302C132.328 59.7302 135.485 83.1055 135.504 83.2538L144.613 125.408C134.197 123.633 120.608 122.587 105.873 122.587C91.1378 122.587 77.5488 123.633 67.1329 125.408L76.2416 83.2538C76.2613 83.1063 79.4171 59.7302 105.873 59.7302Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.746 136.556C161.746 142.341 136.731 147.032 105.873 147.032C75.0152 147.032 50 142.341 50 136.556C50 130.77 75.0152 126.079 105.873 126.079C136.731 126.079 161.746 130.77 161.746 136.556Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.603 149.651C114.603 152.661 113.683 155.548 112.046 157.676C110.409 159.804 108.188 161 105.873 161C103.558 161 101.337 159.804 99.6999 157.676C98.0626 155.548 97.1429 152.661 97.1429 149.651H114.603Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.857 58.8571C112.857 56.7733 112.213 54.7748 111.067 53.3013C109.921 51.8278 108.367 51 106.746 51C105.125 51 103.571 51.8278 102.425 53.3013C101.279 54.7748 100.635 56.7733 100.635 58.8571C100.635 58.8571 103.254 57.9841 106.746 57.9841C110.238 57.9841 112.857 58.8571 112.857 58.8571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.dca8f21aa493ea30b5137e9b1180452b.svg";
export { ForwardRef as ReactComponent };